import * as React from "react";

export default function AnalyticsIcon() {
  return (
    <svg
      className="w-6 h-6 text-gray-800 dark:text-white"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="rgb(30,30,30)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
        d="M4 4v15a1 1 0 0 0 1 1h15M8 16l2.5-5.5 3 3L17.273 7 20 9.667"
      />
    </svg>
  );
}
